<template>
  <v-dialog v-model="dialog" width="40%">
    <v-card>
      <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Publication</v-card-title>
      <br>
      <v-card-text style="font-weight:450; color:black">
        <p><span>Are you sure you want to publish <span class="score">{{ this.selected.length }}</span> review(s) at once?</span></p>
        <p>(if there are any published or closed reviews found in the selection, they will be skipped automatically)</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="warning mx-2" small v-on:click="publish">Yes</v-btn>
        <v-btn color="success" small @click="dialog = false">No</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import { bus } from "../../../../main";

  export default {
    data() {
      return {
        dialog: false,
        user: '',
        selected: [],
      }
    },
    mixins: [],
    methods: {

      open(param, user) {
        this.dialog = true;
        this.selected = param;
        this.user = user;
        this.loading = false;
      },
      notifyParent(param, user) {
        bus.$emit("updateReviewListFastPublication", param, user);
      },
      publish() {
        console.log('publish')
        // axios ccall here
        this.$axios
          .post("ares/json/ares/task/customer_success/revw/quickSaveReview.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "quickSave"
            },
            quickSave: {
              selected: this.selected,
            }
          })
          .then(res => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              console.log('update the array records with new state and user - send notification to parent');
              this.notifyParent(this.selected, this.user);
              this.dialog = false;
            }
          })
          .finally(() => {
          });
      }
    }
  }
</script>
<style scoped>
  .score {
    font-size: 30px !important;
  }
</style>

